import type { CalendarEvent, ActivityEvent, PersonalEvent, SessionEvent } from '../types';
import { EventType, InterventionPlace } from '../types';
import { logger } from '@/common/services/config';

// Mock data for agenda development and testing
export const mockEvents: CalendarEvent[] = [
  // July 2025 Events
  // Activities
  {
    id: '1',
    type: EventType.Activity,
    start: '2025-12-01T08:00:00Z',
    end: '2025-12-01T10:00:00Z',
    label: 'Cours de Mathématiques Avancées',
    description: 'Étude des fonctions complexes et des intégrales multiples',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/meeting1',
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/math-advanced',
    locations: [
      { libelle: 'Salle A-201', code: 'AD201' },
      { libelle: 'Salle A-202', code: 'AD202' },
    ],
    teacher: 'Prof. Martin Dubois',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle A-201, Bâtiment A, Campus Universitaire',
    moreInfo: 'Cours magistral en présentiel avec support numérique',
  } as ActivityEvent,
  {
    id: '2',
    type: EventType.Activity,
    start: '2025-12-01T14:00:00Z',
    end: '2025-12-01T16:00:00Z',
    label: 'TP Informatique - Développement Web',
    description: 'Travaux pratiques sur React et TypeScript',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/web-dev',
    locations: [
      { libelle: 'Laboratoire Informatique B-105', code: 'B105' },
      { libelle: 'Laboratoire Informatique B-106', code: 'B106' },
    ],
    teacher: 'Dr. Sophie Laurent',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Laboratoire Informatique B-105, Bâtiment B, Campus Universitaire',
    moreInfo: 'Travaux pratiques avec ordinateurs individuels fournis',
  } as ActivityEvent,
  {
    id: '3',
    type: EventType.Activity,
    start: '2025-12-02T09:00:00Z',
    end: '2025-12-02T11:00:00Z',
    label: 'Physique Quantique (Distanciel)',
    description: 'Introduction aux principes de la mécanique quantique',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/meeting2',
    zoomLink: 'https://zoom.us/j/123456789',
    moodleLink: 'https://moodle.example.com/course/quantum-physics',
    locations: [],
    teacher: 'Prof. Jean-Pierre Durand',
    interventionPlace: InterventionPlace.Online,
    interventionPlaceAddress: 'Cours en ligne via Teams/Zoom',
    moreInfo: 'Participation depuis votre domicile, matériel de prise de notes requis',
  },
  {
    id: '4',
    type: EventType.Activity,
    start: '2025-12-02T10:00:00Z',
    end: '2025-12-02T12:00:00Z',
    label: 'Chimie Organique - TD',
    description: 'Travaux dirigés sur les réactions organiques',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/organic-chemistry',
    locations: [{ libelle: 'Salle C-301', code: 'SAL_C_301' }],
    teacher: 'Dr. Marie Rousseau',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle C-301, Bâtiment C, Campus Universitaire',
    moreInfo: 'Travaux dirigés avec exercices pratiques en groupe',
  } as ActivityEvent,
  {
    id: '5',
    type: EventType.Activity,
    start: '2025-12-03T08:30:00Z',
    end: '2025-12-03T10:30:00Z',
    label: 'Management Stratégique',
    description: "Analyse des stratégies d'entreprise et études de cas",
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/strategic-management',
    locations: [{ libelle: 'Amphithéâtre A-100', code: 'AMP_A_100' }],
    teacher: 'Prof. Catherine Moreau',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre A-100, Bâtiment A, Campus Universitaire',
    moreInfo: "Cours magistral avec études de cas d'entreprises réelles",
  } as ActivityEvent,
  {
    id: '6',
    type: EventType.Activity,
    start: '2025-12-07T13:30:00Z',
    end: '2025-12-07T15:30:00Z',
    label: 'Anglais des Affaires',
    description: 'Communication professionnelle en anglais',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/business-english',
    locations: [{ libelle: 'Salle B-205', code: 'SAL_B_205' }],
    teacher: 'Ms. Sarah Johnson',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle B-205, Bâtiment B, Campus Universitaire',
    moreInfo: 'Cours interactif avec exercices de conversation et jeux de rôle',
  } as ActivityEvent,
  {
    id: '7',
    type: EventType.Activity,
    start: '2025-12-08T09:00:00Z',
    end: '2025-12-08T12:00:00Z',
    label: 'Examen Final - Économie',
    description: 'Examen final du semestre en économie générale',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Amphithéâtre Principal', code: 'AMP_PRINCIPAL' }],
    teacher: 'Prof. Alexandre Dupont',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre Principal, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Examen surveillé, documents non autorisés, calculatrice fournie',
  },
  {
    id: '8',
    type: EventType.Activity,
    start: '2025-12-10T14:00:00Z',
    end: '2025-12-10T17:00:00Z',
    label: 'Projet de Groupe - Présentation',
    description: 'Présentation finale du projet de développement mobile',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/meeting3',
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/mobile-dev-project',
    locations: [{ libelle: 'Salle de Conférence', code: 'SAL_DE_CONFERE' }],
    teacher: 'Dr. Thomas Leroy',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle de Conférence, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Présentation orale de 20 minutes par groupe, support visuel requis',
  },
  {
    id: '9',
    type: EventType.Activity,
    start: '2025-12-14T10:00:00Z',
    end: '2025-12-14T11:30:00Z',
    label: 'Conférence - Intelligence Artificielle',
    description: "L'IA dans le monde professionnel - Opportunités et défis",
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/conference1',
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [
      { libelle: 'Grand Amphithéâtre', code: 'GA' },
      { libelle: 'Bâtiment Central', code: 'BC' },
    ],
    teacher: 'Dr. Élise Bertrand',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Grand Amphithéâtre, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Conférence ouverte avec session de questions-réponses',
  } as ActivityEvent,
  {
    id: '10',
    type: EventType.Activity,
    start: '2025-12-16T08:00:00Z',
    end: '2025-12-16T10:00:00Z',
    label: "Finance d'Entreprise",
    description: 'Gestion financière et analyse des investissements',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/corporate-finance',
    locations: [{ libelle: 'Salle B-102', code: 'SAL_B_102' }],
    teacher: 'Prof. Michel Garnier',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle B-102, Bâtiment B, Campus Universitaire',
    moreInfo: 'Cours avec exercices pratiques sur les calculs financiers',
  } as ActivityEvent,

  // Additional July 1st events to make it 4+ events
  {
    id: '14',
    type: EventType.Activity,
    start: '2025-12-01T16:30:00Z',
    end: '2025-12-01T18:00:00Z',
    label: 'Séminaire - Innovation Technologique',
    description: 'Les dernières tendances en innovation technologique',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/tech-innovation',
    locations: [{ libelle: 'Amphithéâtre B-100', code: 'AMP_B_100' }],
    teacher: 'Dr. Fabrice Morin',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre B-100, Bâtiment B, Campus Universitaire',
    moreInfo: 'Séminaire avec démonstrations technologiques en direct',
  } as ActivityEvent,
  {
    id: '15',
    type: EventType.Session,
    start: '2025-12-01T19:00:00Z',
    end: '2025-12-01T20:30:00Z',
    label: "Soirée d'Accueil Nouveaux Étudiants",
  },

  // July Appointments
  {
    id: 'apt-july-001',
    type: EventType.PersonalEvent,
    start: '2025-12-01T11:00:00Z',
    end: '2025-12-01T11:30:00Z',
    label: 'Rendez-vous avec le Conseiller Pédagogique',
    description: "Discussion sur l'orientation et les choix de spécialisation pour la rentrée",
    locations: [{ libelle: 'Bureau B-302', code: 'BUR_B_302' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-july-002',
    type: EventType.PersonalEvent,
    start: '2025-12-03T15:00:00Z',
    end: '2025-12-03T16:00:00Z',
    label: 'Entretien Stage Été',
    description: "Entretien pour le stage d'été chez Digital Solutions",
    locations: [{ libelle: 'Salle de réunion C-101', code: 'SAL_DE_REUNION' }],
    isMine: true,
    rsvp: undefined,
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/interview-summer',
  } as PersonalEvent,
  {
    id: 'apt-july-003',
    type: EventType.PersonalEvent,
    start: '2025-12-05T10:00:00Z',
    end: '2025-12-05T10:30:00Z',
    label: 'Réunion Projet Groupe',
    description: "Point d'avancement sur le projet de développement mobile",
    locations: [{ libelle: 'Salle de travail D-205', code: 'SAL_DE_TRAVAIL' }],
    isMine: false,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-july-004',
    type: EventType.PersonalEvent,
    start: '2025-12-09T14:30:00Z',
    end: '2025-12-09T15:00:00Z',
    label: 'Rendez-vous Médecin',
    description: 'Consultation médicale de routine',
    locations: [{ libelle: 'Cabinet Médical - Centre Ville', code: 'CAB_MEDICAL___' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-july-005',
    type: EventType.PersonalEvent,
    start: '2025-12-15T16:00:00Z',
    end: '2025-12-15T17:00:00Z',
    label: 'Entretien Alternance',
    description: 'Entretien pour une alternance chez TechCorp',
    locations: [{ libelle: 'TechCorp - 15 Avenue des Entreprises', code: 'TEC___15_AVENU' }],
    isMine: true,
    rsvp: undefined,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-july-006',
    type: EventType.PersonalEvent,
    start: '2025-12-18T13:00:00Z',
    end: '2025-12-18T14:00:00Z',
    label: 'Déjeuner avec Marie',
    description: 'Pause déjeuner entre amis',
    locations: [{ libelle: 'Café du Campus', code: 'CAF_DU_CAMPUS' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  },

  // Additional events for July 15th to create a day with 4+ events
  {
    id: '14',
    type: EventType.Activity,
    start: '2025-12-15T08:00:00Z',
    end: '2025-12-15T10:00:00Z',
    label: 'Cours de Statistiques',
    description: 'Analyse statistique et probabilités',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/statistics',
    locations: [{ libelle: 'Salle A-105', code: 'SAL_A_105' }],
    teacher: 'Prof. Laurent Petit',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle A-105, Bâtiment A, Campus Universitaire',
    moreInfo: 'Cours de statistiques avec exercices pratiques et logiciels dédiés',
  } as ActivityEvent,
  {
    id: '15',
    type: EventType.Activity,
    start: '2025-12-15T10:30:00Z',
    end: '2025-12-15T12:00:00Z',
    label: 'TP Laboratoire Chimie',
    description: 'Expériences pratiques en chimie analytique',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/chemistry-lab',
    locations: [{ libelle: 'Laboratoire Chimie C-001', code: 'LAB_CHIMIE_C_0' }],
    teacher: 'Dr. Sylvie Marchand',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Laboratoire Chimie C-001, Bâtiment C, Campus Universitaire',
    moreInfo: 'TP de chimie avec manipulations sécurisées, blouse obligatoire',
  },
  {
    id: 'apt-july-007',
    type: EventType.PersonalEvent,
    start: '2025-12-18T13:00:00Z',
    end: '2025-12-18T14:00:00Z',
    label: 'Réunion Club Informatique',
    description: 'Planification des activités du club pour la rentrée',
    locations: [{ libelle: 'Salle de réunion B-210', code: 'SAL_DE_REUNION' }],
    isMine: false,
    rsvp: true,
    teamsLink: undefined,
  },

  // Additional events for August 12th to create another day with 4+ events
  {
    id: '35',
    type: EventType.Activity,
    start: '2026-01-12T08:00:00Z',
    end: '2026-01-12T10:00:00Z',
    label: 'Cours de Communication',
    description: 'Techniques de communication interpersonnelle',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/communication',
    locations: [{ libelle: 'Salle A-302', code: 'SAL_A_302' }],
    teacher: 'Prof. Nathalie Dubois',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle A-302, Bâtiment A, Campus Universitaire',
    moreInfo: 'Cours interactif avec jeux de rôle et exercices pratiques',
  } as ActivityEvent,
  {
    id: '36',
    type: EventType.Activity,
    start: '2026-01-12T10:30:00Z',
    end: '2026-01-12T12:00:00Z',
    label: 'Atelier Rédaction CV',
    description: 'Comment rédiger un CV efficace et attractif',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/cv-workshop',
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Salle de Formation B-401', code: 'SAL_DE_FORMATI' }],
    teacher: 'Mme. Patricia Lefèvre',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle de Formation B-401, Bâtiment B, Campus Universitaire',
    moreInfo: 'Atelier pratique avec révision de CV personnalisée, apporter votre CV actuel',
  },
  {
    id: 'apt-aug-009',
    type: EventType.PersonalEvent,
    start: '2026-01-12T16:00:00Z',
    end: '2026-01-12T17:00:00Z',
    label: 'Séance Orientation Carrière',
    description: "Conseils personnalisés pour l'orientation professionnelle",
    locations: [{ libelle: 'Bureau Orientation D-104', code: 'BUR_ORIENTATIO' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  },

  // July Seances
  {
    id: '11',
    type: EventType.Session,
    start: '2025-07-04T16:30:00Z',
    end: '2025-07-04T18:00:00Z',
    label: 'Séminaire - Entrepreneuriat Numérique',
  } as SessionEvent,
  {
    id: '11',
    type: EventType.Session,
    start: '2025-07-11T13:00:00Z',
    end: '2025-07-11T14:00:00Z',
    label: 'Workshop - Techniques de Présentation',
  } as SessionEvent,
  {
    id: '11',
    type: EventType.Session,
    start: '2025-07-17T14:00:00Z',
    end: '2025-07-17T15:30:00Z',
    label: 'Table Ronde - Carrières Internationales',
  },

  // August 2025 Events
  // Activities
  {
    id: '20',
    type: EventType.Activity,
    start: '2026-01-01T09:00:00Z',
    end: '2026-01-01T11:00:00Z',
    label: "Cours d'Été - Marketing Digital",
    description: 'Introduction aux stratégies de marketing en ligne',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/summer-marketing',
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/digital-marketing',
    locations: [{ libelle: 'Salle A-150', code: 'SAL_A_150' }],
    teacher: 'Dr. Camille Bernard',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle A-150, Bâtiment A, Campus Universitaire',
    moreInfo: "Cours d'été intensif avec études de cas marketing réels",
  } as ActivityEvent,
  {
    id: '21',
    type: EventType.Activity,
    start: '2026-01-02T14:00:00Z',
    end: '2026-01-02T16:00:00Z',
    label: 'Atelier - Design Thinking',
    description: "Méthodologie d'innovation et de résolution de problèmes",
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/design-thinking',
    locations: [{ libelle: 'Salle Créative C-400', code: 'SAL_CREATIVE_C' }],
    teacher: 'Prof. Julien Martinez',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle Créative C-400, Bâtiment C, Campus Universitaire',
    moreInfo: 'Atelier pratique avec matériel créatif et post-it fournis',
  } as ActivityEvent,
  {
    id: '22',
    type: EventType.Activity,
    start: '2026-01-05T10:00:00Z',
    end: '2026-01-05T12:00:00Z',
    label: 'Python pour la Data Science',
    description: "Initiation à l'analyse de données avec Python",
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/python-data',
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/python-data-science',
    locations: [{ libelle: 'Laboratoire Informatique B-201', code: 'LAB_INFORMATIQ' }],
    teacher: 'Dr. Antoine Lefebvre',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Laboratoire Informatique B-201, Bâtiment B, Campus Universitaire',
    moreInfo: 'TP avec Python et Jupyter Notebooks, datasets fournis',
  },
  {
    id: '23',
    type: EventType.Activity,
    start: '2026-01-07T08:30:00Z',
    end: '2026-01-07T10:30:00Z',
    label: 'Économie Internationale',
    description: 'Les enjeux économiques dans un monde globalisé',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/international-economics',
    locations: [{ libelle: 'Amphithéâtre B-50', code: 'AMP_B_50' }],
    teacher: 'Prof. Isabelle Rousseau',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre B-50, Bâtiment B, Campus Universitaire',
    moreInfo: 'Cours magistral avec analyse de données économiques mondiales',
  } as ActivityEvent,
  {
    id: '24',
    type: EventType.Activity,
    start: '2026-01-12T13:30:00Z',
    end: '2026-01-12T15:30:00Z',
    label: 'Gestion de Projet Agile',
    description: 'Méthodes Scrum et Kanban pour la gestion de projet',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/agile-project',
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/agile-management',
    locations: [{ libelle: 'Salle B-305', code: 'SAL_B_305' }],
    teacher: 'M. David Chen',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle B-305, Bâtiment B, Campus Universitaire',
    moreInfo: 'Formation interactive avec mise en pratique des méthodes agiles',
  } as ActivityEvent,
  {
    id: '25',
    type: EventType.Activity,
    start: '2026-01-14T09:00:00Z',
    end: '2026-01-14T11:00:00Z',
    label: 'Droit des Affaires',
    description: "Aspects juridiques de la création d'entreprise",
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/business-law',
    locations: [{ libelle: 'Salle A-203', code: 'SAL_A_203' }],
    teacher: 'Maître Claire Dubois',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle A-203, Bâtiment A, Campus Universitaire',
    moreInfo: "Cours juridique avec étude de cas d'entreprises réelles",
  } as ActivityEvent,
  {
    id: '26',
    type: EventType.Activity,
    start: '2026-01-19T14:00:00Z',
    end: '2026-01-19T17:00:00Z',
    label: 'Soutenance de Mémoire',
    description: "Présentation finale du mémoire de fin d'études",
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/thesis-defense',
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Salle de Soutenance', code: 'SAL_DE_SOUTENA' }],
    teacher: 'Jury Académique',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle de Soutenance, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Soutenance officielle devant jury, présentation de 30 minutes',
  },
  {
    id: '27',
    type: EventType.Activity,
    start: '2026-01-21T10:00:00Z',
    end: '2026-01-21T12:00:00Z',
    label: 'Comptabilité Avancée',
    description: 'Consolidation et normes IFRS',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/advanced-accounting',
    locations: [{ libelle: 'Salle B-150', code: 'SAL_B_150' }],
    teacher: 'Prof. Alain Moreau',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle B-150, Bâtiment B, Campus Universitaire',
    moreInfo: 'Cours avancé avec cas pratiques de consolidation comptable',
  } as ActivityEvent,
  {
    id: '28',
    type: EventType.Activity,
    start: '2026-01-26T08:00:00Z',
    end: '2026-01-26T11:00:00Z',
    label: 'Examen Talent Review (Soutenance de stage) U3',
    description: 'Soutenance de stage organisée par sous-groupe de 5 sur un créneau de 3 heures',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/talent-review',
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Microsoft Teams Meeting', code: 'MIC_TEAMS_MEET' }],
    teacher: 'Animateur « PATRY Fabrice »',
    interventionPlace: InterventionPlace.Online,
    interventionPlaceAddress: 'Réunion Teams en ligne',
    moreInfo: 'Soutenance de stage par sous-groupes, préparation requise',
  },
  {
    id: '29',
    type: EventType.Activity,
    start: '2026-01-28T09:00:00Z',
    end: '2026-01-28T11:00:00Z',
    label: "Stratégie d'Entreprise",
    description: 'Analyse concurrentielle et positionnement stratégique',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/business-strategy',
    locations: [{ libelle: 'Amphithéâtre A-200', code: 'AMP_A_200' }],
    teacher: 'Prof. Vincent Leclerc',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre A-200, Bâtiment A, Campus Universitaire',
    moreInfo: "Cours stratégique avec simulations d'entreprise et jeux sérieux",
  } as ActivityEvent,

  // August 5th - Busy day with 4+ events
  {
    id: '100',
    type: EventType.Activity,
    start: '2026-01-05T08:00:00Z',
    end: '2026-01-05T10:00:00Z',
    label: 'TP - Développement Web Avancé',
    description: 'Travaux pratiques sur React et Vue.js',
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/dev-web-tp',
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/web-dev-advanced',
    locations: [{ libelle: 'Laboratoire Informatique 2', code: 'LAB_INFORMATIQ' }],
    teacher: 'M. Laurent Bernard',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Laboratoire Informatique 2, Bâtiment B, Campus Universitaire',
    moreInfo: 'TP avancé avec projets React et Vue.js, code source à préparer',
  },
  {
    id: '101',
    type: EventType.Activity,
    start: '2026-01-05T10:30:00Z',
    end: '2026-01-05T12:00:00Z',
    label: 'Conférence - IA en Entreprise',
    description: "Les applications de l'intelligence artificielle dans le monde professionnel",
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Amphithéâtre Principal', code: 'AMP_PRINCIPAL' }],
    teacher: 'Dr. Sophie Martin',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre Principal, Bâtiment Central, Campus Universitaire',
    moreInfo: "Conférence avec démonstrations live d'applications IA",
  } as ActivityEvent,
  {
    id: '102',
    type: EventType.Activity,
    start: '2026-01-05T14:00:00Z',
    end: '2026-01-05T16:00:00Z',
    label: 'Atelier - Gestion de Projet Agile',
    description: 'Méthodologies Scrum et Kanban',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/agile-management',
    locations: [{ libelle: 'Salle de Formation C-205', code: 'SAL_DE_FORMATI' }],
    teacher: 'Mme. Sophie Rousseau',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle de Formation C-205, Bâtiment C, Campus Universitaire',
    moreInfo: 'Atelier pratique avec mise en situation et outils collaboratifs',
  } as ActivityEvent,
  {
    id: '103',
    type: EventType.Activity,
    start: '2026-01-05T16:30:00Z',
    end: '2026-01-05T18:00:00Z',
    label: 'Présentation - Projets Étudiants',
    description: "Présentation des projets de fin d'année",
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Amphithéâtre Principal', code: 'AMP_PRINCIPAL' }],
    teacher: 'Comité Pédagogique',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre Principal, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Présentations étudiantes de 15 minutes chacune avec évaluation',
  } as ActivityEvent,

  // August 18th - Another busy day with 5 events
  {
    id: '104',
    type: EventType.Activity,
    start: '2026-01-18T09:00:00Z',
    end: '2026-01-18T10:30:00Z',
    label: 'Cours - Bases de Données Avancées',
    description: 'Optimisation des requêtes SQL et NoSQL',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/advanced-databases',
    locations: [{ libelle: 'Amphithéâtre A-100', code: 'AMP_A_100' }],
    teacher: 'Dr. Patricia Lefort',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre A-100, Bâtiment A, Campus Universitaire',
    moreInfo: 'Cours avancé avec exercices pratiques sur SGBD',
  } as ActivityEvent,
  {
    id: '105',
    type: EventType.Activity,
    start: '2026-01-18T11:00:00Z',
    end: '2026-01-18T12:30:00Z',
    label: 'TP - Sécurité Informatique',
    description: 'Tests de pénétration et audit de sécurité',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/cybersecurity',
    locations: [{ libelle: 'Laboratoire Sécurité', code: 'LAB_SECURITE' }],
    teacher: 'M. Kevin Dupont',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Laboratoire Sécurité, Bâtiment Informatique, Campus Universitaire',
    moreInfo: 'TP sécurisé avec machines dédiées et environnement contrôlé',
  } as ActivityEvent,
  {
    id: '106',
    type: EventType.Activity,
    start: '2026-01-18T13:30:00Z',
    end: '2026-01-18T15:00:00Z',
    label: 'Séminaire - Blockchain et Crypto',
    description: 'Technologies blockchain et applications décentralisées',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/blockchain',
    locations: [{ libelle: 'Salle de Conférence B-301', code: 'SAL_DE_CONFERE' }],
    teacher: 'Dr. Marc Legrand',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Salle de Conférence B-301, Bâtiment B, Campus Universitaire',
    moreInfo: 'Séminaire technique avec démonstrations blockchain en temps réel',
  } as ActivityEvent,
  {
    id: '107',
    type: EventType.Activity,
    start: '2026-01-18T15:30:00Z',
    end: '2026-01-18T17:00:00Z',
    label: 'Table Ronde - Métiers du Numérique',
    description: 'Rencontre avec des professionnels du secteur IT',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Hall Principal', code: 'HAL_PRINCIPAL' }],
    teacher: 'Invités Professionnels',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Hall Principal, Bâtiment Central, Campus Universitaire',
    moreInfo: "Table ronde interactive avec professionnels de l'IT et networking",
  } as ActivityEvent,
  {
    id: '108',
    type: EventType.Activity,
    start: '2026-01-18T18:00:00Z',
    end: '2026-01-18T19:30:00Z',
    label: 'Événement - Soirée Networking',
    description: 'Rencontres avec des professionnels du secteur IT',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Hall Principal', code: 'HAL_PRINCIPAL' }],
    teacher: undefined,
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Hall Principal, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Événement social avec cocktail et opportunités de networking professionnel',
  } as ActivityEvent,

  // August 25th - Busy day with graduation events
  {
    id: '109',
    type: EventType.Activity,
    start: '2026-01-25T08:30:00Z',
    end: '2026-01-25T10:00:00Z',
    label: 'Cours - Architecture Logicielle',
    description: 'Patterns de conception et microservices',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/software-architecture',
    locations: [{ libelle: 'Amphithéâtre B-200', code: 'AMP_B_200' }],
    teacher: 'Dr. Michel Garcin',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Amphithéâtre B-200, Bâtiment B, Campus Universitaire',
    moreInfo: "Cours avancé avec diagrammes d'architecture et études de cas",
  } as ActivityEvent,
  {
    id: '110',
    type: EventType.Activity,
    start: '2026-01-25T10:30:00Z',
    end: '2026-01-25T12:00:00Z',
    label: 'TP - Cloud Computing',
    description: "Déploiement d'applications sur AWS/Azure",
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: 'https://moodle.example.com/course/cloud-computing',
    locations: [{ libelle: 'Laboratoire Cloud', code: 'LAB_CLOUD' }],
    teacher: 'Mme. Isabelle Martin',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Laboratoire Cloud, Bâtiment Informatique, Campus Universitaire',
    moreInfo: 'TP pratique avec accès cloud AWS/Azure, crédits fournis',
  },
  {
    id: '111',
    type: EventType.Activity,
    start: '2026-01-25T14:00:00Z',
    end: '2026-01-25T15:30:00Z',
    label: 'Répétition - Cérémonie Diplômes',
    description: 'Répétition générale pour la cérémonie de remise des diplômes',
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Grand Amphithéâtre', code: 'GRA_AMPHITHEAT' }],
    teacher: 'Équipe Organisation',
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Grand Amphithéâtre, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Répétition obligatoire pour tous les diplômés, tenue formelle requise',
  },
  {
    id: '112',
    type: EventType.Activity,
    start: '2026-01-25T16:00:00Z',
    end: '2026-01-25T18:00:00Z',
    label: 'Cérémonie - Remise des Diplômes',
    description: "Cérémonie officielle de remise des diplômes de fin d'année",
    teamsLink: undefined,
    zoomLink: undefined,
    moodleLink: undefined,
    locations: [{ libelle: 'Grand Amphithéâtre', code: 'GRA_AMPHITHEAT' }],
    teacher: "Direction de l'École",
    interventionPlace: InterventionPlace.InPerson,
    interventionPlaceAddress: 'Grand Amphithéâtre, Bâtiment Central, Campus Universitaire',
    moreInfo: 'Cérémonie officielle avec remise de diplômes et discours',
  } as ActivityEvent,

  // August Appointments
  {
    id: 'apt-aug-001',
    type: EventType.PersonalEvent,
    start: '2026-01-01T16:00:00Z',
    end: '2026-01-01T17:00:00Z',
    label: 'Réunion Équipe Projet',
    description: 'Planification des dernières étapes du projet',
    locations: [{ libelle: 'Salle de travail D-102', code: 'SAL_DE_TRAVAIL' }],
    isMine: false,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-002',
    type: EventType.PersonalEvent,
    start: '2026-01-06T11:30:00Z',
    end: '2026-01-06T12:00:00Z',
    label: 'Rendez-vous Banque',
    description: 'Ouverture de compte épargne étudiant',
    locations: [{ libelle: 'Agence Bancaire - Centre Ville', code: 'AGE_BANCAIRE__' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-003',
    type: EventType.PersonalEvent,
    start: '2026-01-08T14:00:00Z',
    end: '2026-01-08T15:00:00Z',
    label: 'Entretien Job Étudiant',
    description: 'Entretien pour un poste de serveur à temps partiel',
    locations: [{ libelle: 'Restaurant Le Gourmet', code: 'RES_LE_GOURMET' }],
    isMine: true,
    rsvp: undefined,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-004',
    type: EventType.PersonalEvent,
    start: '2026-01-13T15:30:00Z',
    end: '2026-01-13T16:30:00Z',
    label: 'Suivi Pédagogique',
    description: 'Bilan de progression avec le tuteur académique',
    locations: [{ libelle: 'Bureau A-305', code: 'BUR_A_305' }],
    isMine: true,
    rsvp: true,
    teamsLink: 'https://teams.microsoft.com/l/meetup-join/academic-follow-up',
  } as PersonalEvent,
  {
    id: 'apt-aug-005',
    type: EventType.PersonalEvent,
    start: '2026-01-18T10:00:00Z',
    end: '2026-01-18T10:30:00Z',
    label: 'Préparation Soutenance',
    description: 'Répétition avant la soutenance de mémoire',
    locations: [{ libelle: 'Salle de préparation C-205', code: 'SAL_DE_PREPARA' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-006',
    type: EventType.PersonalEvent,
    start: '2026-01-22T12:00:00Z',
    end: '2026-01-22T13:00:00Z',
    label: 'Anglais renforcé',
    description: "Session de révision pour l'examen d'anglais",
    locations: [{ libelle: 'Salle de langue B-110', code: 'SAL_DE_LANGUE_' }],
    isMine: true,
    rsvp: undefined,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-007',
    type: EventType.PersonalEvent,
    start: '2026-01-27T10:00:00Z',
    end: '2026-01-27T11:00:00Z',
    label: 'Validation stage',
    description: 'Signature des documents de fin de stage',
    locations: [{ libelle: 'Service Stages - Bâtiment Administration', code: 'SER_STAGES___B' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-008',
    type: EventType.PersonalEvent,
    start: '2026-01-29T14:30:00Z',
    end: '2026-01-29T15:30:00Z',
    label: 'Inscription Semestre Automne',
    description: "Finalisation des inscriptions pour le semestre d'automne",
    locations: [{ libelle: 'Secrétariat Pédagogique', code: 'SEC_PEDAGOGIQU' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  },

  // Additional appointments for busy days
  {
    id: 'apt-aug-009',
    type: EventType.PersonalEvent,
    start: '2026-01-05T12:30:00Z',
    end: '2026-01-05T13:00:00Z',
    label: 'Entretien - Orientation Spécialisation',
    description: "Discussion sur le choix de spécialisation pour l'année prochaine",
    locations: [{ libelle: 'Bureau du Conseiller Pédagogique', code: 'BUR_DU_CONSEIL' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-010',
    type: EventType.PersonalEvent,
    start: '2026-01-18T12:30:00Z',
    end: '2026-01-18T13:00:00Z',
    label: 'Rendez-vous Carrière',
    description: 'Préparation CV et entretiens professionnels',
    locations: [{ libelle: 'Service Orientation Professionnelle', code: 'SER_ORIENTATIO' }],
    isMine: true,
    rsvp: true,
    teamsLink: undefined,
  } as PersonalEvent,
  {
    id: 'apt-aug-011',
    type: EventType.PersonalEvent,
    start: '2026-01-25T12:30:00Z',
    end: '2026-01-25T13:00:00Z',
    label: "Entretien Fin d'Études",
    description: "Bilan de parcours et perspectives d'avenir",
    locations: [{ libelle: 'Direction des Études', code: 'DIR_DES_ETUDES' }],
    isMine: false,
    rsvp: true,
    teamsLink: undefined,
  },

  // August Seances
  {
    id: '30',
    type: EventType.Session,
    start: '2026-01-04T16:30:00Z',
    end: '2026-01-04T18:00:00Z',
    label: 'Conférence - Transition Écologique',
  } as SessionEvent,
  {
    id: '11',
    type: EventType.Session,
    start: '2026-01-09T13:00:00Z',
    end: '2026-01-09T14:00:00Z',
    label: 'Séminaire - Leadership et Management',
  } as SessionEvent,
  {
    id: '11',
    type: EventType.Session,
    start: '2026-01-15T14:00:00Z',
    end: '2026-01-15T15:30:00Z',
    label: 'Workshop - Networking Professionnel',
  } as SessionEvent,
  {
    id: '11',
    type: EventType.Session,
    start: '2026-01-23T10:00:00Z',
    end: '2026-01-23T11:30:00Z',
    label: 'Forum Entreprises - Rencontres Recruteurs',
  } as SessionEvent,
  {
    id: '11',
    type: EventType.Session,
    start: '2026-01-30T15:00:00Z',
    end: '2026-01-30T16:30:00Z',
    label: "Cérémonie de Fin d'Année Académique",
  } as SessionEvent,
];

export class MockAgendaService {
  static async getEvents(startDate?: string, endDate?: string): Promise<CalendarEvent[]> {
    await new Promise((resolve) => setTimeout(resolve, 800));

    if (!startDate || !endDate) {
      logger.log('No date range provided, returning all events:', mockEvents.length);
      return mockEvents;
    }

    // Filter events by date range with more flexible matching
    const filteredEvents = mockEvents.filter((event) => {
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);
      const rangeStart = new Date(startDate);
      const rangeEnd = new Date(endDate);

      // Event overlaps with the range if:
      // - Event starts before range ends AND event ends after range starts
      const isInRange = eventStart <= rangeEnd && eventEnd >= rangeStart;

      if (isInRange) {
        logger.log(`Event "${event.label}" (${event.start}) is in range ${startDate} - ${endDate}`);
      }

      return isInRange;
    });

    logger.log(
      `Filtered events: ${filteredEvents.length} out of ${mockEvents.length} total events`
    );
    return filteredEvents;
  }

  static async getEventById(id: string | number): Promise<CalendarEvent | undefined> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));

    return mockEvents.find((event) => event.id.toString() === id.toString());
  }

  static async createEvent(event: Partial<CalendarEvent>): Promise<CalendarEvent> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const newEvent: CalendarEvent = {
      id: event.type === EventType.PersonalEvent ? `apt-${Date.now()}` : Date.now().toString(),
      type: event.type || EventType.Activity,
      start: event.start || new Date().toISOString(),
      end: event.end || new Date(Date.now() + 3600000).toISOString(), // +1 hour
      label: event.label || 'Nouvel Événement',
      ...event,
    } as CalendarEvent;

    mockEvents.push(newEvent);
    return newEvent;
  }

  static async updateEvent(
    id: string | number,
    updates: Partial<CalendarEvent>
  ): Promise<CalendarEvent> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 800));

    const eventIndex = mockEvents.findIndex((event) => event.id.toString() === id.toString());
    if (eventIndex === -1) {
      logger.error('Event not found');
      throw new Error('Event not found');
    }

    const currentEvent = mockEvents[eventIndex];
    const updatedEvent = { ...currentEvent, ...updates } as CalendarEvent;
    mockEvents[eventIndex] = updatedEvent;
    return updatedEvent;
  }

  static async deleteEvent(id: string | number): Promise<void> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 600));

    const eventIndex = mockEvents.findIndex((event) => event.id.toString() === id.toString());
    if (eventIndex === -1) {
      throw new Error('Event not found');
    }

    mockEvents.splice(eventIndex, 1);
  }

  static async acceptAppointmentRsvp(id: string | number): Promise<void> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 400));

    const event = mockEvents.find((event) => event.id.toString() === id.toString());
    if (!event || event.type !== EventType.PersonalEvent) {
      throw new Error('Appointment not found');
    }

    event.rsvp = true;
  }

  static async declineAppointmentRsvp(id: string | number): Promise<void> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 400));

    const event = mockEvents.find((event) => event.id.toString() === id.toString());
    if (!event || event.type !== EventType.PersonalEvent) {
      throw new Error('Appointment not found');
    }

    event.rsvp = false;
  }

  static async getEventsForToday(): Promise<CalendarEvent[]> {
    const today = new Date().toISOString().split('T')[0];
    return this.getEvents(`${today}T00:00:00Z`, `${today}T23:59:59Z`);
  }
}
